// import Lawyer from '@/view/card/Lawyer.vue'
// import LawOffice from '@/view/card/LawOffice.vue'

const routes = [
  {
    path: '/card/lawyer',
    name: '/card/lawyer',
    component: () => import('@/view/card/Lawyer.vue')
  },
  {
    path: '/card/lawOffice',
    name: '/card/lawOffice',
    component: () => import('@/view/card/LawOffice.vue')
  },
]

export default { routes }